import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { useContext, useEffect, useState } from 'react';
import calloutIcon from '../../../assets/images/icons/icon-accede-y-gestiona.svg';
import GlobalContext from '../../../contexts/globalContext';
import { DocumentType, TabsEnum } from '../../../enums/enums';
import useMobile from '../../../hooks/useMobile';
import UseTraceItemShipping from '../../../hooks/UseTraceItemShipping';
import UseVerificationDigit from '../../../hooks/useVerificationDigit';
import { GigyaAccount } from '../../../interfaces/GigyaAccount';
import { getCompanyName } from '@/services/getCompanyNameService';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { firstUpperOnly } from '../../../shared/utils/stringUtilities';
import { normalizeWords } from '../../../utils/normalizeWords';
import GenericToast from '../generic-toast/genericToast';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js';
import './login.scss';
import { navigate } from 'gatsby';
interface File {
    url: string;
}
interface Imagen {
    file: File;
    title: string;
    gatsbyImageData?: any;
}
interface ReferencesInterface {
    imagen: Imagen[] | null;
    lista: string | null;
    nombre: string;
    redireccion: string;
    titulo: string;
}
interface MenuUserInterface {
    titulo: string;
    descripcion: any;
    nombreEmpresa: string | null;
    referencias: ReferencesInterface[];
}
interface LoginInterface {
    title: string;
    isMenuActive?: boolean;
    openModal?: () => void;
    setOpenHeaderModal?: () => void;
    closeModal?: () => void;
    login: () => void;
    logout: () => void;
    updateProfile: () => void;
    gigyaAccount?: GigyaAccount;
    menuUser: MenuUserInterface;
    closeMenu?: () => void;
    isPrivate?: boolean;
}

const Login = (props: LoginInterface) => {
    const { isBrowser, document, window, localStorage } = useBrowserMode();
    const [isShow, setIsShow] = useState(false);
    const [showCallout, setShowCallout] = useState(false);
    const [isShowSubOption, setIsShowSubOption] = useState<any>(null);
    const gigyaAccount = props.gigyaAccount;
    const loggedMenu = props.menuUser
        ? props.menuUser.filter(
              (item) => !item.titulo.includes('usuario deslogeado')
          )[0]
        : [];
    const loginCTA = props.menuUser
        ? props.menuUser.filter((item) =>
              item.titulo.includes('usuario deslogeado')
          )[0]
        : [];
    const mobile = useMobile();
    const closeMenu = props.closeMenu;
    const openModal = props.openModal;
    const { business, selectedTab, gigyaContext, userInfoContext } =
        useContext(GlobalContext);
    const [showConfirmation, setShowConfirmation] = useState<any>(false);
    const cookies = new Cookies();

    const getCleanBusinessList = (originalBusiness) => {
        const businesDocs = originalBusiness?.map((bussines, index) => {
            return {
                ...bussines,
                label: `${
                    DocumentType[bussines.companyDocType as keyof DocumentType]
                } ${bussines.companyDocID}`,
                value: index,
            };
        });

        const newList: any = [];

        businesDocs?.forEach((item) => {
            if (
                businesDocs.filter((e) => e.companyDocID === item.companyDocID)
                    .length > 1
            ) {
                if (
                    newList.findIndex(function (e) {
                        return e.companyDocID === item.companyDocID;
                    }) === -1
                ) {
                    const duplicatedElements = businesDocs.filter(
                        (e) => e.companyDocID === item.companyDocID
                    );
                    const permitLIst = duplicatedElements.map((subItem) => {
                        return subItem.serviceId;
                    });
                    item.serviceId = permitLIst;
                    newList.push(item);
                }
            } else {
                item.serviceId = [item.serviceId];
                newList.push(item);
            }
        });

        return newList;
    };

    const businessDocs = getCleanBusinessList(
        gigyaContext.gigyaAccount?.data.servicesAuth
    );

    useEffect(() => {
        if (isBrowser && !gigyaAccount) {
            setShowCallout(true);
            setTimeout(function () {
                closeToast();
            }, 5000);
        }
    }, []);

    const selectCompany = async (doc) => {
        doShow(false);
        const docToSend =
            doc.companyDocID.replace(/\s/g, '') +
            (doc.companyDocType === 'CO1N'
                ? UseVerificationDigit(String(doc.companyDocID))
                : '');

        try {
            const getBusinessName = await getCompanyName(
                docToSend,
                cookies.get('token')
            );
            if (
                getBusinessName?.status === 200 &&
                getBusinessName?.data?.records?.length > 0
            ) {
                if (
                    getBusinessName.data.records &&
                    getBusinessName.data.records[0].status === 'VIGEN'
                ) {
                    doc.label = getBusinessName.data.records[0].companyName;
                    business?.set(doc);
                    cookies.set(
                        'CURRENT_BUSINESS',
                        CryptoJS.AES.encrypt(
                            JSON.stringify(doc),
                            'comfama'
                        ).toString(),
                        {
                            path: '/',
                            expires: new Date(
                                new Date(Date.now() + 60 * 10000)
                            ),
                        }
                    );
                    setShowConfirmation(
                        <GenericToast
                            setActiveToast={setShowConfirmation}
                            isOk={true}
                            message="Cambio de empresa exitoso"
                            position="up-right"
                        />
                    );
                } else {
                    setShowConfirmation(
                        <GenericToast
                            setActiveToast={setShowConfirmation}
                            isOk={false}
                            message={
                                getBusinessName?.data?.records &&
                                getBusinessName?.data?.records[0]?.status !==
                                    'VIGEN'
                                    ? 'La empresa no se encuentra vigente'
                                    : 'No fue posible cambiar de empresa'
                            }
                            position="up-right"
                        />
                    );
                }
            } else {
                setShowConfirmation(
                    <GenericToast
                        setActiveToast={setShowConfirmation}
                        isOk={false}
                        message="No fue posible cambiar de empresa"
                        position="up-right"
                    />
                );
            }
        } catch (error) {
            console.log('get company error', error);
        }
    };

    const closeToast = () => {
        const callout = document.getElementById('a-login__cta-callout');
        if (callout) {
            callout.classList.add('__hidden');
            setTimeout(() => {
                callout.classList.remove('__hidden');
                setShowCallout(false);
            }, 200);
        } else {
            setShowCallout(false);
        }
    };

    const doShow = (isToShow: boolean) => {
        setIsShow(isToShow);
        setIsShowSubOption(null);
        closeMenu && closeMenu();
    };

    const openRedirection = (redireccion) => {
        window?.open(
            redireccion,
            redireccion.includes('https') || redireccion.includes('www')
                ? '_blank'
                : '_self'
        );
    };

    const [scroll] = useState(0);
    useEffect(() => {
        document.addEventListener('scroll', () => {
            const posicionActual = window?.pageYOffset;
            if (Math.abs(posicionActual - scroll) > 100) {
                doShow(false);
            }
        });
    }, []);

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
                <p className="a-login__cta-callout-description">{children}</p>
            ),
        },
    };

    return (
        <div className="a-login">
            {gigyaAccount ? (
                <div
                    className={`a-login__container ${
                        props.isMenuActive ? 'a-login__container-open' : ''
                    }`}
                >
                    <div
                        className={`a-login__container__circle 
                  ${isShow ? 'a-login__container__circle-open' : ''} 
                  ${
                      gigyaAccount.profile?.gender === 'f'
                          ? 'circle-female'
                          : gigyaAccount.profile?.gender === 'm'
                          ? 'circle-male'
                          : ''
                  }  gtmMenuTransPerfilUsuario`}
                        onClick={() => doShow(!isShow)}
                    >
                        {gigyaAccount.profile &&
                        gigyaAccount.profile?.thumbnailURL ? (
                            <div className="a-login__container__circle__cover gtmMenuTransPerfilUsuario">
                                <img
                                    loading="lazy"
                                    className="a-login__container__circle__cover__img gtmMenuTransPerfilUsuario"
                                    alt={gigyaAccount.profile.firstName}
                                    src={gigyaAccount.profile.thumbnailURL}
                                    title={gigyaAccount.profile.firstName}
                                />
                            </div>
                        ) : (
                            <p>{`${gigyaAccount.profile?.firstName.charAt(
                                0
                            )}${gigyaAccount.profile?.lastName.charAt(0)}`}</p>
                        )}
                    </div>
                    <div
                        className="a-login__container__name hide-mobile"
                        onClick={() => doShow(!isShow)}
                    >
                        <span className="a-login__container__title hide-mobile">
                            {`¡Hola ${firstUpperOnly(
                                gigyaAccount.profile.firstName
                            )} ${firstUpperOnly(
                                gigyaAccount.profile.lastName
                            )}!`}
                        </span>
                        {business?.get &&
                            selectedTab?.get === TabsEnum.BUSINESS &&
                            !isShow && (
                                <span className="a-login__container__title-business">
                                    {business.get.label}
                                </span>
                            )}
                    </div>
                    <i
                        className={`a-login__container__icon ${
                            isShow ? 'icon-caret-up' : 'icon-caret-down'
                        } hide-mobile gtmMenuTransPerfilUsuario`}
                        onClick={() => doShow(!isShow)}
                    />
                    {isShow && (
                        <div className="a-login__container__float-box">
                            <ul className="a-login__container__float-box__options">
                                {loggedMenu.referencias.map((value, index) => {
                                    return (
                                        <>
                                            <li
                                                className={
                                                    'a-login__container__float-box__options__option' +
                                                    (value.lista &&
                                                    value.lista.length > 0 &&
                                                    isShowSubOption === index
                                                        ? ' --no-bottom-padding'
                                                        : '') +
                                                    (value.nombre ===
                                                        'Tus empresas' &&
                                                    (!businessDocs ||
                                                        businessDocs.length <=
                                                            0)
                                                        ? ' --no-display'
                                                        : '')
                                                }
                                                key={index}
                                                onClick={() => {
                                                    if (
                                                        value.nombre ===
                                                            'Cerrar Sesión' ||
                                                        value.nombre ===
                                                            'Cerrar sesión'
                                                    ) {
                                                        props.logout();
                                                        business?.set(
                                                            undefined
                                                        );
                                                        cookies.remove(
                                                            'CURRENT_BUSINESS',
                                                            { path: '/' }
                                                        );
                                                        cookies.remove('uid-r');
                                                        cookies.remove('token');
                                                        localStorage.removeItem(
                                                            'uid-pre'
                                                        );
                                                        localStorage.removeItem(
                                                            'uid-r'
                                                        );
                                                        doShow(false);
                                                        if (props.isPrivate) {
                                                            if (
                                                                window?.location?.pathname?.includes(
                                                                    '/certificados'
                                                                )
                                                            ) {
                                                                navigate(
                                                                    '/certificados'
                                                                );
                                                            } else if (
                                                                window?.location?.pathname?.includes(
                                                                    '/pagos'
                                                                )
                                                            ) {
                                                                navigate(
                                                                    '/pagos'
                                                                );
                                                            } else {
                                                                navigate('/');
                                                            }
                                                        }

                                                        navigate('/');
                                                    } else {
                                                        if (
                                                            value.nombre ===
                                                                'Ir a mi perfil' ||
                                                            value.nombre ===
                                                                'Actualizar mis datos empresariales'
                                                        ) {
                                                            if (
                                                                gigyaContext?.gigyaAccount
                                                            ) {
                                                                UseTraceItemShipping(
                                                                    gigyaContext
                                                                        ?.gigyaAccount
                                                                        ?.profile
                                                                        .firstName +
                                                                        ' ' +
                                                                        (gigyaContext
                                                                            .gigyaAccount
                                                                            .data
                                                                            .secondName
                                                                            ? gigyaContext
                                                                                  .gigyaAccount
                                                                                  .data
                                                                                  .secondName +
                                                                              ' '
                                                                            : '') +
                                                                        gigyaContext
                                                                            .gigyaAccount
                                                                            .profile
                                                                            .lastName +
                                                                        (gigyaContext
                                                                            .gigyaAccount
                                                                            .data
                                                                            .secondLastName
                                                                            ? ' ' +
                                                                              gigyaContext
                                                                                  .gigyaAccount
                                                                                  .data
                                                                                  .secondLastName
                                                                            : ''),
                                                                    gigyaContext
                                                                        ?.gigyaAccount
                                                                        ?.data
                                                                        .docNumber,
                                                                    gigyaContext
                                                                        ?.gigyaAccount
                                                                        ?.data
                                                                        .docType,
                                                                    gigyaContext
                                                                        ?.gigyaAccount
                                                                        ?.profile
                                                                        .email,
                                                                    'redirection',
                                                                    `${normalizeWords(
                                                                        value.nombre
                                                                    )}`,
                                                                    userInfoContext
                                                                        .data
                                                                        ?.userJwt
                                                                );

                                                                if (
                                                                    value.nombre ===
                                                                    'Ir a mi perfil'
                                                                ) {
                                                                    props.updateProfile();
                                                                    doShow(
                                                                        false
                                                                    );
                                                                }
                                                            }
                                                            value.redireccion &&
                                                                (!value.lista ||
                                                                    value.lista
                                                                        .length <=
                                                                        0) &&
                                                                value.nombre ===
                                                                    'Actualizar mis datos empresariales' &&
                                                                openRedirection(
                                                                    value.redireccion
                                                                );
                                                        } else {
                                                            value.redireccion &&
                                                                (!value.lista ||
                                                                    value.lista
                                                                        .length <=
                                                                        0) &&
                                                                openRedirection(
                                                                    value.redireccion
                                                                );
                                                        }
                                                    }
                                                }}
                                            >
                                                <img
                                                    className="a-login__container__float-box__options__option-image"
                                                    src={
                                                        value.imagen[0].file.url
                                                    }
                                                    alt={value.imagen[0].title}
                                                    title={
                                                        value.imagen[0].title
                                                    }
                                                    onClick={() => {
                                                        if (
                                                            value.nombre ===
                                                                'Cerrar Sesión' ||
                                                            value.nombre ===
                                                                'Cerrar sesión'
                                                        ) {
                                                            props.logout();
                                                            // setCheckUser(false)
                                                            business?.set(
                                                                undefined
                                                            );
                                                            cookies.remove(
                                                                'CURRENT_BUSINESS',
                                                                { path: '/' }
                                                            );
                                                            cookies.remove(
                                                                'uid-r'
                                                            );
                                                            cookies.remove(
                                                                'token'
                                                            );
                                                            localStorage.removeItem(
                                                                'uid-pre'
                                                            );
                                                            localStorage.removeItem(
                                                                'uid-r'
                                                            );
                                                            doShow(false);
                                                            if (
                                                                props.isPrivate
                                                            ) {
                                                                if (
                                                                    window?.location?.pathname?.includes(
                                                                        '/certificados'
                                                                    )
                                                                ) {
                                                                    navigate(
                                                                        '/certificados'
                                                                    );
                                                                } else if (
                                                                    window?.location?.pathname?.includes(
                                                                        '/pagos'
                                                                    )
                                                                ) {
                                                                    navigate(
                                                                        '/pagos'
                                                                    );
                                                                } else {
                                                                    navigate(
                                                                        '/'
                                                                    );
                                                                }
                                                            }

                                                            navigate('/');
                                                        } else {
                                                            value.redireccion &&
                                                            value.lista &&
                                                            value.lista.length >
                                                                0 &&
                                                            props.setOpenHeaderModal
                                                                ? props.setOpenHeaderModal()
                                                                : openModal &&
                                                                  openModal();
                                                            doShow(false);
                                                        }
                                                    }}
                                                />
                                                <p
                                                    className="a-login__container__float-box__options__option-name"
                                                    onClick={() => {
                                                        if (
                                                            value.nombre ===
                                                                'Cerrar Sesión' ||
                                                            value.nombre ===
                                                                'Cerrar sesión'
                                                        ) {
                                                            props.logout();
                                                            // setCheckUser(false)
                                                            business?.set(
                                                                undefined
                                                            );
                                                            cookies.remove(
                                                                'CURRENT_BUSINESS',
                                                                { path: '/' }
                                                            );
                                                            cookies.remove(
                                                                'uid-r'
                                                            );
                                                            cookies.remove(
                                                                'token'
                                                            );
                                                            localStorage.removeItem(
                                                                'uid-pre'
                                                            );
                                                            localStorage.removeItem(
                                                                'uid-r'
                                                            );
                                                            doShow(false);
                                                            if (
                                                                props.isPrivate
                                                            ) {
                                                                if (
                                                                    window?.location?.pathname?.includes(
                                                                        '/certificados'
                                                                    )
                                                                ) {
                                                                    navigate(
                                                                        '/certificados'
                                                                    );
                                                                } else if (
                                                                    window?.location?.pathname?.includes(
                                                                        '/pagos'
                                                                    )
                                                                ) {
                                                                    navigate(
                                                                        '/pagos'
                                                                    );
                                                                } else {
                                                                    navigate(
                                                                        '/'
                                                                    );
                                                                }
                                                            }
                                                            setTimeout(() => {
                                                                navigate('/');
                                                            }, 1000);
                                                        } else {
                                                            value.redireccion &&
                                                            value.lista &&
                                                            value.lista.length >
                                                                0 &&
                                                            props.setOpenHeaderModal
                                                                ? props.setOpenHeaderModal()
                                                                : openModal &&
                                                                  openModal();
                                                            doShow(false);
                                                        }
                                                    }}
                                                >
                                                    {value.nombre}
                                                </p>

                                                {((value.lista &&
                                                    value.lista.length > 0) ||
                                                    value.nombre.includes(
                                                        'empresas'
                                                    )) && (
                                                    <i
                                                        className={`a-login__container__float-box__options__option-icon ${
                                                            isShowSubOption ===
                                                                index &&
                                                            'icon-caret-right'
                                                        }`}
                                                        onClick={() => {
                                                            props.setOpenHeaderModal
                                                                ? props.setOpenHeaderModal()
                                                                : openModal &&
                                                                  openModal();
                                                            doShow(false);
                                                        }}
                                                    />
                                                )}
                                            </li>
                                            {value.nombre.includes(
                                                'empresas'
                                            ) && isShowSubOption === index ? (
                                                <div className="a-login__container__float-box__options__option-sub-box">
                                                    {businessDocs
                                                        ?.slice(0, 7)
                                                        .map(
                                                            (doc, indexSub) => {
                                                                return (
                                                                    <p
                                                                        className="a-login__container__float-box__options__option-subOption"
                                                                        key={
                                                                            indexSub
                                                                        }
                                                                        onClick={() => {
                                                                            selectCompany(
                                                                                doc
                                                                            );
                                                                        }}
                                                                    >
                                                                        {
                                                                            doc.label
                                                                        }
                                                                    </p>
                                                                );
                                                            }
                                                        )}
                                                    {businessDocs &&
                                                        businessDocs.length >
                                                            7 && (
                                                            <p
                                                                className="a-login__container__float-box__options__option-subOption__see-more"
                                                                onClick={() => {
                                                                    props.setOpenHeaderModal
                                                                        ? props.setOpenHeaderModal()
                                                                        : openModal &&
                                                                          openModal();
                                                                    doShow(
                                                                        false
                                                                    );
                                                                }}
                                                            >
                                                                Ver más empresas
                                                            </p>
                                                        )}
                                                </div>
                                            ) : (
                                                value.lista &&
                                                value.lista.length > 0 &&
                                                isShowSubOption === index && (
                                                    <div className="a-login__container__float-box__options__option-sub-box">
                                                        {value.lista.map(
                                                            (
                                                                info,
                                                                indexSub
                                                            ) => {
                                                                return (
                                                                    <p
                                                                        className="a-login__container__float-box__options__option-subOption"
                                                                        key={
                                                                            indexSub
                                                                        }
                                                                    >
                                                                        {info}
                                                                    </p>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                )
                                            )}
                                        </>
                                    );
                                })}
                            </ul>
                            <div
                                className="a-login__container__float-box__background"
                                onClick={() => doShow(false)}
                            ></div>
                        </div>
                    )}
                    {showConfirmation && <>{showConfirmation}</>}
                </div>
            ) : (
                <div className={'a-login__cta'}>
                    {!mobile ? (
                        <i className="icon-user" />
                    ) : (
                        <button
                            className="a-login__button-mobile"
                            onClick={props.login}
                        >
                            <i className="icon-user" />
                        </button>
                    )}
                    <span
                        className={`a-login__title hide-mobile ${
                            props.isMenuActive ? 'a-login__title-open' : ''
                        } gtmMenuTransIniciarSesion`}
                        onClick={props.login}
                    >
                        {loginCTA.referencias[0].nombre}
                    </span>
                </div>
            )}
        </div>
    );
};

export default Login;
